(() => {
  if (window.htlShowroomHoursLoaded) return;
  window.htlShowroomHoursLoaded = true;
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const opening = 9 * 60;
  const closing = [0, 16 * 60, 16 * 60, 16 * 60, 16 * 60, 16 * 60, 13 * 60];

  function refresh() {
    const parts = Object.fromEntries(clock.formatToParts(new Date()).map(part => [part.type, part.value]));
    const day = weekdays.indexOf(parts.weekday);
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);
    if (day < 0 || !Number.isFinite(minutes)) return;
    const open = closing[day] > 0 && minutes >= opening && minutes < closing[day];
    const today = closing[day] > 0 && minutes < opening;
    let nextDay = (day + 1) % 7;
    while (!closing[nextDay]) nextDay = (nextDay + 1) % 7;
    document.querySelectorAll('[data-htl-showroom-status]').forEach(element => {
      const label = open ? element.dataset.labelOpen : today ? element.dataset.labelToday :
        element.dataset.labelNext.replace('__DAY__', element.getAttribute(`data-day-${nextDay}`));
      if (element.textContent !== label) element.textContent = label;
      element.dataset.open = String(open);
    });
  }

  let timer;
  function update() {
    clearTimeout(timer);
    refresh();
    timer = setTimeout(update, 60000 - Date.now() % 60000);
  }
  update();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
})();
